import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import { LanguageDropdown } from '../../components';
import config from '../../config';

import css from './TopbarSearchForm.css';

class TopbarSearchFormComponent extends Component {
  render() {
    const { rootClassName, className } = this.props;
    const classes = classNames(rootClassName, className);

    // Language selection dropdown
    const handleLanguageChange = e => {
      if (e.target.value === 'en') {
        window.location.assign(process.env.REACT_APP_ENGLISH_ROOT_URL);
      } else if (e.target.value === 'fi') {
        window.location.assign(process.env.REACT_APP_FINNISH_ROOT_URL);
      }
    };

    const languages = [
      { value: 'en', label: 'EN' },
      { value: 'fi', label: 'FI' },
    ];

    const locale = config.locale;

    const getCurrentLanguage = () => {
      return locale || 'fi';
    };

    return (
      <div className={classes}>
        <LanguageDropdown
          className={css.languageSelect}
          currentLanguage={getCurrentLanguage()}
          languages={languages}
          onChange={handleLanguageChange}
        />
      </div>
    );
  }
}

const { func, string, bool } = PropTypes;

TopbarSearchFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  desktopInputRoot: null,
  isMobile: false,
};

TopbarSearchFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  desktopInputRoot: string,
  onSubmit: func.isRequired,
  isMobile: bool,

  // from injectIntl
  intl: intlShape.isRequired,
};

const TopbarSearchForm = injectIntl(TopbarSearchFormComponent);

export default TopbarSearchForm;
